import SmartFeedEngine from "@/smart-feed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import { useOrganizationStore } from "@/stores/organization-store";

export const useOrgExpertServicePackageFeedStore = defineSmartFeedPiniaStore("org-expert-service-package-feed-store", {
  state: () => ({
    smartFeedEngine: new SmartFeedEngine(),
    defaultFilterValues: {
      orgId: {
        "key": "org_id",
        "payload": useOrganizationStore().orgProfileData.org_id,
      },
    },
  }),
  getters: {
    feedUrl() {
      return `/expert/${useOrganizationStore().orgProfileData.org_id}/packages`;
    },
  },
});
